import React, { Component } from "react";
import { Endpoints,REVIEW} from "npmlinks-constants";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
import {
  GridRow,
  GridColumn,
  Button,
  Modal,
  Utils
} from "arv-reactcomponents";
import MainCarousel from "../../MainCarousel";
import GetRating from "../GetRating";

@inject("CommonStore")
@observer
class CustomerReviewPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      imageIndex: this.props.index || 0,
      mainImage: null,
      reviews: [],
      imageList: [],
      reviews: {},
      viewMore: false
    };
    this.setImageIndex = this.setImageIndex.bind(this);
    this.setMainImage = this.setMainImage.bind(this);
  }

  setImageIndex(imageIndex) {
    this.setState({ imageIndex });
  }

  setMainImage(mainImage) {
    this.setState({ mainImage });
  }

  viewMoreClick = e => {
    e.preventDefault();
    const { viewMore } = this.state;
    this.setState({ viewMore: !viewMore });
  };

  getReviewText = (reviewText, props, viewMore) => {
    const ending = "...";
    let storyText;
    const { isDesktop } = this.props.CommonStore;
    if (reviewText.length <= 120) {
      return <p className="nw-review-storytext">{reviewText}</p>;
    }
    if (reviewText.length > 120 && !viewMore) {
      storyText = (
        <p className="nw-review-storytext">
          {reviewText.substring(0, 120)}
          {ending}{" "}
          <span
            className="nw-pdp-aboutbrandaccordionreadmore"
            onKeyPress={Utils.noop}
            onClick={this.viewMoreClick}
          >
            {" "}
            {REVIEW.REVIEW_READMORE}
          </span>
        </p>
      );
    } else {
      storyText = (
        <p className="nw-review-storytext">
          {reviewText}
          <span
            className="nw-pdp-aboutbrandaccordionreadmore"
            onKeyPress={Utils.noop}
            onClick={this.viewMoreClick}
          >
            {" "}
            {REVIEW.REVIEW_READLESS}
          </span>
        </p>
      );
    }
    return storyText;
  };

  render() {
    const { imageIndex, list, mainImage, viewMore } = this.state;
    const { isDesktop } = this.props.CommonStore;
    const { reviews } = this.props;
    const { props } = this;
    return (
      <GridRow className="nw-pdp-row-customerphotos">
        {reviews && reviews.images && reviews.images.length && (
          <GridColumn className="nwc-grid-col-sm-6">
            <div className="nw-pdp-customerreviewpage">
              <GridRow>
                <div className="nw-pdp-image-reviews">
                  <MainCarousel.component
                    list={reviews.images}
                    setImageIndex={this.setImageIndex}
                    ProductLoader={false}
                    imageIndex={imageIndex}
                    index={imageIndex}
                    mainImage={mainImage}
                    reviews={true}
                  />
                </div>
              </GridRow>
            </div>
          </GridColumn>
        )}
        <GridColumn className="nwc-grid-col-sm-6">
          <div className="nw-review-customerreview">
            <div className="nw-product-ratingcontainer">
              <div className="nw-rating-icon">
                <GetRating.component
                  starSize="16px"
                  isShowRating={true}
                  rating={reviews.rating}
                />
              </div>
            </div>
            <div>
              <div className="nw-review-date">
                {reviews.userInfo.name} | {reviews.userSubmissionDate}
              </div>
              <div className="nw-review-text-customerphotos">
                {this.getReviewText(reviews.text, props, viewMore)}
              </div>
            </div>
            {isDesktop &&
              reviews.images &&
              reviews.images.map(image => (
                <img
                  className="nw-review-customerimage"
                  src={image.thumbnail}
                  alt="nnnow"
                />
              ))}
          </div>
        </GridColumn>
      </GridRow>
    );
  }
}

CustomerReviewPage.propTypes = {
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired
  }).isRequired
};

const getFinalComponent = component =>
  inject("CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: CustomerReviewPage.wrappedComponent,
  component: CustomerReviewPage
};

export default ProjectComponent;
